var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29207 10.293C8.10526 10.4819 8.00049 10.7368 8.00049 11.0025C8.00049 11.2682 8.10526 11.5231 8.29207 11.712L11.2311 14.677C11.4491 14.892 11.7311 14.999 12.0101 14.999C12.2891 14.999 12.5661 14.892 12.7791 14.677L15.7091 11.722C15.8956 11.533 16.0002 11.2781 16.0002 11.0125C16.0002 10.7469 15.8956 10.492 15.7091 10.303C15.6172 10.2098 15.5078 10.1358 15.3871 10.0853C15.2664 10.0348 15.1369 10.0088 15.0061 10.0088C14.8752 10.0088 14.7457 10.0348 14.625 10.0853C14.5043 10.1358 14.3949 10.2098 14.3031 10.303L12.0051 12.62L9.69807 10.293C9.60603 10.2002 9.49652 10.1265 9.37586 10.0762C9.25521 10.0259 9.12578 10.0001 8.99507 10.0001C8.86435 10.0001 8.73493 10.0259 8.61427 10.0762C8.49361 10.1265 8.38411 10.2002 8.29207 10.293Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cb68f89097e62154d8136a787a53d2cb.svg";
export { ForwardRef as ReactComponent };